import React, { useRef, useState, useEffect } from 'react';
import { Button, Modal } from 'antd';
import Draggable from 'react-draggable';
const AntDraggableModal = ({ title, extra, children, ...props }) => {
  const [disabled, setDisabled] = useState(true);
  const [bounds, setBounds] = useState({
    left: 0,
    top: 0,
    bottom: 0,
    right: 0,
  });
  const draggleRef = useRef(null);
  const onStart = (_event, uiData) => {
    const { clientWidth, clientHeight } = window.document.documentElement;
    const targetRect = draggleRef.current?.getBoundingClientRect();
    if (!targetRect) {
      return;
    }

    // 获取模态框的宽度和高度
    const modalWidth = targetRect.right - targetRect.left;
    const modalHeight = targetRect.bottom - targetRect.top;

    setBounds({
      left: -targetRect.left + uiData.x - modalWidth + 100,
      right: clientWidth - (targetRect.right - uiData.x) + modalWidth - 100,
      top: -targetRect.top + uiData.y,
      bottom: clientHeight - 100,
    });
  };

  return (
    <Modal
      title={
        <div
          style={{
            width: '100%',
            cursor: 'move'
          }}
          onMouseOver={() => {
            if (disabled) {
              setDisabled(false);
            }
          }}
          onMouseOut={() => {
            setDisabled(true);
          }}
        >
          {title}
        </div>
      }
      {...props}
      modalRender={(modal) => (
        <Draggable
          disabled={disabled}
          bounds={bounds}
          onStart={(event, uiData) => onStart(event, uiData)}
        >
          <div ref={draggleRef}>{modal}</div>
        </Draggable>
      )}
      transitionName=""
      maskTransitionName=""
      keyboard={false}
    // destroyOnClose={true} // 滚动条复位相关
    >
      {children}
    </Modal>
  );
};
export default AntDraggableModal;
